// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4520":"css/admin-app.6665","7078":"css/app.6665"}[chunkId] + ".css";
};